
(function () {
  "use strict";

  /* =========================================================
     HEALIX — COMPLETE YOUR LOOK AMPLITUDE EXPERIMENT
  ========================================================= */

  var AMPLITUDE_API_KEY = "9d253bc63558834ac094e9f724a29c8e";
  var DEPLOYMENT_KEY = "client-urIh4iccbe0cLpFejsTGBfiYjpbqjIR9";
  var EXPERIMENT_KEY = "healix-cart-drawer-complete-your-look";

  // These must match the variant values in Amplitude.
  var CONTROL_VALUE = "multiple-products";
  var TREATMENT_VALUE = "single-products";

  var CONTROL_SELECTOR = "[data-healix-complete-look-all]";
  var TREATMENT_SELECTOR = "[data-healix-complete-look-one]";
  var VARIANT_ATTRIBUTE = "data-healix-complete-look-variant";

  var ADD_TO_CART_EVENT = "complete_your_look_add_to_cart";
  var SECTION_VIEWED_EVENT = "complete_your_look_section_viewed";
  var PRODUCT_CLICK_EVENT = "complete_your_look_product_clicked";
  var UPSELL_REVENUE_EVENT = "complete_your_look_upsell_revenue";

  var IDENTITY_WAIT_MS = 10000;
  var IDENTITY_POLL_MS = 200;
  var ASSIGNMENT_RETRY_MS = 1500;
  var CART_INTENT_MAX_AGE_MS = 15000;

  var state = {
    amplitude: null,
    experiment: null,
    amplitudeReady: false,
    ready: false,
    assignmentValid: false,
    variant: null,
    variantObject: null,
    allVariants: null,
    exposureTracked: false,
    initialized: false,
    eventQueue: [],
    exposureObserver: null,
    visibilityObserver: null,
    observedElements: new WeakSet()
  };

  var pendingCartAdds = [];
  var originalFetch = null;

  /* =========================================================
     LOGGING
  ========================================================= */

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[Healix Amplitude]");
    console.log.apply(console, args);
  }

  function warn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[Healix Amplitude]");
    console.warn.apply(console, args);
  }

  function logError(message, error) {
    console.error("[Healix Amplitude] " + message, error || "");
  }

  /* =========================================================
     SECTION ELEMENTS
  ========================================================= */

  function getControlElements() {
    return Array.prototype.slice.call(
      document.querySelectorAll(CONTROL_SELECTOR)
    );
  }

  function getTreatmentElements() {
    return Array.prototype.slice.call(
      document.querySelectorAll(TREATMENT_SELECTOR)
    );
  }

  function installVariantGuardStyles() {
    if (document.getElementById("healix-complete-look-variant-guard")) {
      return;
    }

    var style = document.createElement("style");
    style.id = "healix-complete-look-variant-guard";

    style.textContent =
      'html[' + VARIANT_ATTRIBUTE + '="pending"] ' +
      CONTROL_SELECTOR + ', ' +
      'html[' + VARIANT_ATTRIBUTE + '="pending"] ' +
      TREATMENT_SELECTOR + ' {' +
      "display:none !important;" +
      "}" +

      'html[' + VARIANT_ATTRIBUTE + '="' + CONTROL_VALUE + '"] ' +
      TREATMENT_SELECTOR + ', ' +

      'html[' + VARIANT_ATTRIBUTE + '="' + TREATMENT_VALUE + '"] ' +
      CONTROL_SELECTOR + ' {' +
      "display:none !important;" +
      "}";

    (document.head || document.documentElement).appendChild(style);

    document.documentElement.setAttribute(VARIANT_ATTRIBUTE, "pending");
  }

  function setElementVisible(element, visible) {
    if (!element) return;

    element.hidden = !visible;

    if (visible) {
      element.removeAttribute("aria-hidden");
      element.style.removeProperty("display");
    } else {
      element.setAttribute("aria-hidden", "true");
      element.style.setProperty("display", "none", "important");
    }
  }

  function showOnlyVariant(variant) {
    var controls = getControlElements();
    var treatments = getTreatmentElements();

    if (
      variant !== CONTROL_VALUE &&
      variant !== TREATMENT_VALUE
    ) {
      document.documentElement.setAttribute(VARIANT_ATTRIBUTE, "pending");

      controls.concat(treatments).forEach(function (element) {
        setElementVisible(element, false);
      });

      return;
    }

    document.documentElement.setAttribute(VARIANT_ATTRIBUTE, variant);

    controls.forEach(function (element) {
      setElementVisible(element, variant === CONTROL_VALUE);
    });

    treatments.forEach(function (element) {
      setElementVisible(element, variant === TREATMENT_VALUE);
    });

    log("Displaying assigned variant:", variant, {
      controlSections: controls.length,
      treatmentSections: treatments.length
    });

    startExposureObserver();
  }

  function isElementActuallyVisible(element) {
    if (!element || !element.isConnected) return false;

    var current = element;

    while (current && current.nodeType === 1) {
      var style = window.getComputedStyle(current);

      if (
        style.display === "none" ||
        style.visibility === "hidden" ||
        Number(style.opacity) === 0 ||
        current.hidden
      ) {
        return false;
      }

      current = current.parentElement;
    }

    var rect = element.getBoundingClientRect();

    return rect.width > 0 && rect.height > 0;
  }

  /* =========================================================
     ANALYTICS IDENTITY
  ========================================================= */

  function getAmplitudeIdentity() {
    if (!state.amplitude) return {};

    var user = {};

    try {
      var deviceId =
        state.amplitude.getDeviceId &&
        state.amplitude.getDeviceId();

      var userId =
        state.amplitude.getUserId &&
        state.amplitude.getUserId();

      if (deviceId) user.device_id = deviceId;
      if (userId) user.user_id = userId;
    } catch (error) {
      logError("Could not read Analytics identity.", error);
    }

    return user;
  }

  function waitForAmplitudeIdentity() {
    return new Promise(function (resolve, reject) {
      var startedAt = Date.now();

      function checkIdentity() {
        var user = getAmplitudeIdentity();

        if (user.device_id || user.user_id) {
          resolve(user);
          return;
        }

        if (Date.now() - startedAt >= IDENTITY_WAIT_MS) {
          reject(new Error(
            "Amplitude identity unavailable. Check SDK initialization and browser storage."
          ));
          return;
        }

        window.setTimeout(checkIdentity, IDENTITY_POLL_MS);
      }

      checkIdentity();
    });
  }

  /* =========================================================
     EVENT TRACKING
  ========================================================= */

  function canTrackExperimentEvents() {
    return Boolean(
      state.amplitudeReady &&
      state.ready &&
      state.assignmentValid &&
      state.amplitude &&
      state.variant
    );
  }

  function track(eventName, properties) {
    properties = properties || {};

    if (!canTrackExperimentEvents()) {
      state.eventQueue.push({
        eventName: eventName,
        properties: Object.assign({}, properties)
      });

      log("Queued event until assignment is ready:", eventName);
      return false;
    }

    var eventProperties = Object.assign({}, properties, {
      experiment_key: EXPERIMENT_KEY,
      experiment_variant: state.variant
    });

    try {
      var result = state.amplitude.track(eventName, eventProperties);

      log("Submitted event:", eventName, eventProperties);

      if (result && typeof result.promise === "function") {
        result.promise()
          .then(function (response) {
            log("Amplitude event response:", eventName, response);
          })
          .catch(function (error) {
            logError("Amplitude delivery failed: " + eventName, error);
          });
      }

      return true;
    } catch (error) {
      logError("Unable to submit event: " + eventName, error);
      return false;
    }
  }

  function flushEventQueue() {
    if (!canTrackExperimentEvents()) return;

    var queued = state.eventQueue.slice();
    state.eventQueue = [];

    queued.forEach(function (item) {
      track(item.eventName, item.properties);
    });

    if (queued.length) {
      log("Flushed queued events:", queued.length);
    }
  }

  function trackSectionViewed(properties) {
    return track(SECTION_VIEWED_EVENT, properties);
  }

  function trackProductClick(properties) {
    return track(PRODUCT_CLICK_EVENT, properties);
  }

  function trackAddToCart(properties) {
    return track(ADD_TO_CART_EVENT, properties);
  }

  /* =========================================================
     DETECT THE SOURCE VARIANT
  ========================================================= */

  function getCompleteLookSource(target) {
    if (!target || !target.closest) return null;

    var allSection = target.closest(CONTROL_SELECTOR);
    var oneSection = target.closest(TREATMENT_SELECTOR);

    if (allSection) {
      return {
        variant: CONTROL_VALUE,
        section: "multiple-products",
        element: allSection
      };
    }

    if (oneSection) {
      return {
        variant: TREATMENT_VALUE,
        section: "single-products",
        element: oneSection
      };
    }

    return null;
  }

  function isShopifyAddUrl(url) {
    if (!url) return false;

    try {
      var parsed = new URL(url, window.location.origin);

      return /\/cart\/add(?:\.js)?\/?$/.test(parsed.pathname);
    } catch (error) {
      return /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url));
    }
  }
/* =========================================================
   REPLACE CART-ADD HELPERS WITH THIS CODE
========================================================= */

function getCartAddDetails(body) {
  var details = { items: [] };

  if (!body) return details;

  try {
    var parsed = null;

    if (typeof body === "string") {
      try {
        parsed = JSON.parse(body);
      } catch (_) {
        parsed = Object.fromEntries(
          new URLSearchParams(body).entries()
        );
      }
    } else if (body instanceof URLSearchParams) {
      parsed = Object.fromEntries(body.entries());
    } else if (
      typeof FormData !== "undefined" &&
      body instanceof FormData
    ) {
      parsed = Object.fromEntries(body.entries());
    } else if (
      typeof body === "object" &&
      !(
        typeof Request !== "undefined" &&
        body instanceof Request
      )
    ) {
      parsed = body;
    }

    if (!parsed) return details;

    // Support Shopify single-item and multi-item requests.
    var requestedItems = Array.isArray(parsed.items)
      ? parsed.items
      : [parsed];

    details.items = requestedItems
      .map(function (entry) {
        if (!entry) return null;

        var id =
          entry.id ||
          entry.variant_id ||
          entry["items[0][id]"];

        var quantity =
          entry.quantity ||
          entry["items[0][quantity]"] ||
          1;

        if (!id) return null;

        return {
          variant_id: String(id),
          quantity: Number(quantity) || 1
        };
      })
      .filter(Boolean);
  } catch (error) {
    log("Could not parse Shopify cart-add request.", error);
  }

  return details;
}


/*
 * Read the request body without consuming the original request.
 */
async function readCartRequestDetails(request, init) {
  try {
    if (init && init.body != null) {
      return getCartAddDetails(init.body);
    }

    if (
      typeof Request !== "undefined" &&
      request instanceof Request
    ) {
      var clonedRequest = request.clone();
      var contentType =
        clonedRequest.headers.get("content-type") || "";

      if (
        contentType.indexOf("application/json") !== -1 ||
        contentType.indexOf("application/x-www-form-urlencoded") !== -1
      ) {
        return getCartAddDetails(await clonedRequest.text());
      }

      if (contentType.indexOf("multipart/form-data") !== -1) {
        return getCartAddDetails(await clonedRequest.formData());
      }
    }
  } catch (error) {
    log("Could not read cart request details.", error);
  }

  return { items: [] };
}



/* =========================================================
   FIX: DYNAMIC COMPLETE YOUR LOOK VARIANT SELECTION
   The recommendation may open a variant sheet before the
   actual Shopify /cart/add.js request contains the variant ID.
========================================================= */

function recordCartAddIntent(source, details) {
  if (!source) return;

  details = details || {};

  // Variant ID may not exist until the shopper selects a size.
  pendingCartAdds = pendingCartAdds.filter(function (item) {
    return Date.now() - item.timestamp < CART_INTENT_MAX_AGE_MS;
  });

  pendingCartAdds.push({
    source: {
      variant: source.variant,
      section: source.section
    },
    details: {
      variant_id: details.variant_id
        ? String(details.variant_id)
        : null,
      quantity: Number(details.quantity) > 0
        ? Number(details.quantity)
        : 1
    },
    timestamp: Date.now()
  });

  // Keep the queue bounded.
  if (pendingCartAdds.length > 30) {
    pendingCartAdds = pendingCartAdds.slice(-30);
  }

  log("Recorded Complete Your Look intent:", {
    sectionVariant: source.variant,
    variantId: details.variant_id || "awaiting Shopify request"
  });
}


function consumeCartAddIntent(requestDetails) {
  var now = Date.now();

  pendingCartAdds = pendingCartAdds.filter(function (item) {
    return now - item.timestamp < CART_INTENT_MAX_AGE_MS;
  });

  var requestItems =
    requestDetails && Array.isArray(requestDetails.items)
      ? requestDetails.items
      : [];

  if (!requestItems.length) {
    warn("Cart request has no readable variant ID.");
    return null;
  }

  // First preference: exact variant-ID match.
  for (var i = pendingCartAdds.length - 1; i >= 0; i--) {
    var intent = pendingCartAdds[i];

    var exactMatch = requestItems.find(function (item) {
      return String(item.variant_id) ===
        String(intent.details.variant_id);
    });

    if (intent.details.variant_id && exactMatch) {
      pendingCartAdds.splice(i, 1);

      intent.details.quantity = exactMatch.quantity;
      intent.matchedRequestVariantId = exactMatch.variant_id;

      log("Matched exact upsell variant:", exactMatch.variant_id);

      return intent;
    }
  }

  /*
   * Second preference: a recent recommendation click whose
   * variant ID was not available until the size/variant sheet
   * submitted its Shopify cart request.
   *
   * Only use a source-only intent if exactly one request item
   * is present, avoiding ambiguous multi-product attribution.
   */
  if (requestItems.length === 1) {
    for (var j = pendingCartAdds.length - 1; j >= 0; j--) {
      var pending = pendingCartAdds[j];

      if (pending.details.variant_id) continue;

      pendingCartAdds.splice(j, 1);

      pending.details.variant_id =
        String(requestItems[0].variant_id);

      pending.details.quantity =
        Number(requestItems[0].quantity) || 1;

      pending.matchedRequestVariantId =
        String(requestItems[0].variant_id);

      log("Matched selected variant from Shopify request:", {
        sectionVariant: pending.source.variant,
        variantId: pending.details.variant_id,
        quantity: pending.details.quantity
      });

      return pending;
    }
  }

  log("No matching Complete Your Look intent for this cart request.");
  return null;
}


/* =========================================================
   VALIDATE AND TRACK SUCCESSFUL UPSELL REVENUE
========================================================= */

async function recordSuccessfulCartAdd(response, intent) {
  if (!intent || !response || !response.ok) return;

  // Never attribute revenue to an invalid assignment or
  // to a variant other than the visitor's assigned variant.
  if (
    !state.assignmentValid ||
    !state.ready ||
    intent.source.variant !== state.variant
  ) {
    log("Skipping conversion: assignment mismatch.", {
      clickedVariant: intent.source.variant,
      assignedVariant: state.variant
    });
    return;
  }

  try {
    var data = await response.clone().json();

    var items = Array.isArray(data.items)
      ? data.items
      : [data];

    var requestedVariantId = String(
      intent.details.variant_id
    );

    // The response must contain the exact clicked variant.
    var item = items.find(function (entry) {
      return String(entry.id) === requestedVariantId;
    });

    if (!item) {
      warn("Upsell conversion skipped: response variant mismatch.", {
        requestedVariantId: requestedVariantId,
        returnedVariantIds: items.map(function (entry) {
          return String(entry.id);
        })
      });
      return;
    }

    // Use Shopify's actual returned quantity.
    var quantity = Number(item.quantity);

    if (!Number.isFinite(quantity) || quantity <= 0) {
      warn("Invalid returned Shopify quantity.", item);
      return;
    }

    /*
     * Shopify Ajax cart prices are represented in subunits.
     * Use the line total when available to avoid multiplying
     * an already-totalled price by quantity a second time.
     */
    var lineTotalSubunits;

    if (item.final_line_price != null) {
      lineTotalSubunits = Number(item.final_line_price);
    } else if (item.line_price != null) {
      lineTotalSubunits = Number(item.line_price);
    } else {
      var unitPriceSubunits = Number(
        item.final_price != null
          ? item.final_price
          : item.price
      );

      lineTotalSubunits = unitPriceSubunits * quantity;
    }

    if (
      !Number.isFinite(lineTotalSubunits) ||
      lineTotalSubunits < 0
    ) {
      warn("Invalid Shopify line total.", item);
      return;
    }

    var currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "USD";

    // Healix's store is using USD. Shopify Ajax price values
    // are converted from subunits to the currency amount here.
    var upsellRevenue = Number(
      (lineTotalSubunits / 100).toFixed(2)
    );

    var commonProperties = {
      source: "complete_your_look",
      section_variant: intent.source.variant,
      section_name: intent.source.section,
      variant_id: requestedVariantId,
      product_id: item.product_id != null
        ? String(item.product_id)
        : null,
      product_title: item.product_title || item.title || "",
      quantity: quantity,
      currency: currency
    };

    // Successful cart-add event.
    trackAddToCart(Object.assign({}, commonProperties, {
      cart_add_success: true
    }));

    // Revenue event: revenue is the actual returned line total.
    track(UPSELL_REVENUE_EVENT, Object.assign(
      {},
      commonProperties,
      {
        upsell_revenue: upsellRevenue
      }
    ));

    log("Validated upsell revenue:", {
      variant: state.variant,
      variant_id: requestedVariantId,
      quantity: quantity,
      revenue: upsellRevenue,
      currency: currency
    });
  } catch (error) {
    logError("Could not validate or track upsell revenue.", error);
  }
}



  /* =========================================================
     CLICK TRACKING AND SHOPIFY CART REQUESTS
  ========================================================= */

 /* =========================================================
   CLICK TRACKING AND VERIFIED SHOPIFY CART REQUESTS
========================================================= */

function installCompleteLookCartTracking() {
  if (window.__healixCompleteLookCartTrackingInstalled) return;

  window.__healixCompleteLookCartTrackingInstalled = true;

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var source = getCompleteLookSource(target);
    if (!source) return;

    var button = target.closest(
      'button, input[type="submit"], [type="submit"], ' +
      '[name="add"], [data-add-to-cart], ' +
      '[data-product-add], .product-form__submit'
    );

    if (!button) return;

    var form = button.closest("form");
    var details = {};

    if (form) {
      var idField = form.querySelector('[name="id"]');
      var quantityField = form.querySelector('[name="quantity"]');

      if (idField && idField.value) {
        details.variant_id = String(idField.value);
      }

      if (quantityField && quantityField.value) {
        details.quantity = Number(quantityField.value) || 1;
      }
    }

    // Optional theme-specific variant ID fallback.
    if (!details.variant_id) {
      var variantId =
        button.getAttribute("data-variant-id") ||
        button.getAttribute("data-product-variant-id");

      if (variantId) {
        details.variant_id = String(variantId);
      }
    }

    // Revenue attribution requires a known variant ID.
   
recordCartAddIntent(source, details);

trackProductClick({
  source: "complete_your_look",
  section_variant: source.variant,
  section_name: source.section,
  variant_id: details.variant_id || null
});

  }, true);

  /*
   * Intercept fetch without consuming the original request
   * or changing the response returned to the Shopify theme.
   */
  if (window.fetch && !window.__healixCompleteLookFetchWrapped) {
    window.__healixCompleteLookFetchWrapped = true;

    originalFetch = window.fetch;

    window.fetch = async function () {
      var args = arguments;
      var request = args[0];

      var requestUrl =
        typeof request === "string"
          ? request
          : request && request.url;

      var isCartAdd = isShopifyAddUrl(requestUrl);

      // Read and match only actual Shopify add requests.
      var intent = null;

      if (isCartAdd) {
        var requestDetails = await readCartRequestDetails(
          request,
          args[1]
        );

        intent = consumeCartAddIntent(requestDetails);

        if (intent) {
          log("Matched cart request to upsell click:", {
            variant: intent.source.variant,
            variant_id: intent.details.variant_id,
            quantity: intent.details.quantity
          });
        }
      }

      var response = await originalFetch.apply(this, args);

      if (isCartAdd && intent) {
        // Tracking errors must not break Shopify's cart flow.
        recordSuccessfulCartAdd(response, intent).catch(function (error) {
          logError("Upsell tracking failed.", error);
        });
      }

      return response;
    };
  }

  log("Verified Complete Your Look cart tracking installed.");
}

  /* =========================================================
     EXPOSURE TRACKING
  ========================================================= */

  function createExposureTrackingProvider() {
    return {
      track: function (exposure) {
        if (!state.amplitude || !exposure) {
          logError("Missing Analytics or exposure data.");
          return;
        }

        var properties = {
          flag_key: exposure.flag_key,
          variant: exposure.variant
        };

        if (exposure.experiment_key) {
          properties.experiment_key = exposure.experiment_key;
        }

        try {
          var result = state.amplitude.track("$exposure", properties);

          if (result && typeof result.promise === "function") {
            result.promise().catch(function (error) {
              logError("Exposure delivery failed.", error);
            });
          }

          log("Exposure event submitted:", properties);
        } catch (error) {
          logError("Failed to send exposure.", error);
        }
      }
    };
  }

  function recordExperimentExposure() {
    if (
      state.exposureTracked ||
      !state.assignmentValid ||
      !state.ready ||
      !state.experiment ||
      !state.variant
    ) {
      return;
    }

    try {
      state.experiment.exposure(EXPERIMENT_KEY);
      state.exposureTracked = true;

      log("Experiment exposure recorded:", {
        experiment: EXPERIMENT_KEY,
        variant: state.variant
      });

      trackSectionViewed({
        source: "cart_drawer",
        section_variant: state.variant
      });
    } catch (error) {
      logError("Could not record experiment exposure.", error);
    }
  }

  function startExposureObserver() {
    if (!state.assignmentValid || !state.ready) return;

    var elements = getControlElements().concat(getTreatmentElements());

    if (!elements.length) return;

    if (!("IntersectionObserver" in window)) {
      elements.forEach(function (element) {
        if (isElementActuallyVisible(element)) {
          recordExperimentExposure();
        }
      });
      return;
    }

    if (!state.exposureObserver) {
      state.exposureObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (
              entry.isIntersecting &&
              entry.intersectionRatio > 0 &&
              isElementActuallyVisible(entry.target)
            ) {
              recordExperimentExposure();
            }
          });
        },
        { threshold: 0.01 }
      );
    }

    elements.forEach(function (element) {
      if (!state.observedElements.has(element)) {
        state.observedElements.add(element);
        state.exposureObserver.observe(element);
      }
    });
  }

  /* =========================================================
     DYNAMIC SHOPIFY SECTIONS
  ========================================================= */

  function startVisibilityObserver() {
    if (state.visibilityObserver || !document.documentElement) return;

    var scheduled = false;

    state.visibilityObserver = new MutationObserver(function () {
      if (!state.assignmentValid || !state.variant || scheduled) return;

      scheduled = true;

      window.requestAnimationFrame(function () {
        scheduled = false;

        if (state.assignmentValid && state.variant) {
          showOnlyVariant(state.variant);
        }
      });
    });

    state.visibilityObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  /* =========================================================
     LOAD AMPLITUDE ANALYTICS
  ========================================================= */

  async function loadAmplitude() {
    var module = await import(
      "https://cdn.jsdelivr.net/npm/@amplitude/analytics-browser@2.47.2/+esm"
    );

    var amplitude = module.amplitude || module.default || module;

    if (
      !amplitude ||
      typeof amplitude.init !== "function" ||
      typeof amplitude.track !== "function"
    ) {
      throw new Error("Amplitude Analytics SDK failed to load.");
    }

    await amplitude.init(AMPLITUDE_API_KEY, undefined, {
      serverZone: "US",
      autocapture: false
    });

    state.amplitude = amplitude;
    state.amplitudeReady = true;

    await waitForAmplitudeIdentity();

    log("Amplitude Analytics ready.");
    return amplitude;
  }

  /* =========================================================
     LOAD AMPLITUDE EXPERIMENT
  ========================================================= */

  async function loadExperiment() {
    var module = await import(
      "https://cdn.jsdelivr.net/npm/@amplitude/experiment-js-client@1.23.1/+esm"
    );

    var Experiment = module.Experiment || module.default || module;

    if (
      !Experiment ||
      typeof Experiment.initialize !== "function"
    ) {
      throw new Error("Amplitude Experiment SDK failed to load.");
    }

    state.experiment = Experiment.initialize(DEPLOYMENT_KEY, {
      logLevel: 4,

      userProvider: {
        getUser: function () {
          return getAmplitudeIdentity();
        }
      },

      automaticExposureTracking: false,

      exposureTrackingProvider: createExposureTrackingProvider()
    });

    log("Amplitude Experiment initialized.");
    return state.experiment;
  }

/* =========================================================
   PERSIST EXPERIMENT ATTRIBUTION TO THE SHOPIFY CART
========================================================= */

function persistExperimentAttributionToCart() {
  if (
    !state.assignmentValid ||
    !state.variant ||
    !state.amplitude
  ) {
    return Promise.resolve(false);
  }

  var deviceId = "";

  try {
    deviceId = state.amplitude.getDeviceId() || "";
  } catch (error) {
    logError("Could not read Amplitude device ID.", error);
  }

  if (!deviceId) {
    warn("No Amplitude device ID; cart attribution not saved.");
    return Promise.resolve(false);
  }

  return fetch(
    (window.Shopify && window.Shopify.routes &&
      window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/") + "cart/update.js",
    {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        attributes: {
          "__healix_experiment_key": EXPERIMENT_KEY,
          "__healix_experiment_variant": state.variant,
          "__healix_amplitude_device_id": deviceId
        }
      })
    }
  )
    .then(function (response) {
      if (!response.ok) {
        throw new Error("Cart attribution update failed: " + response.status);
      }

      log("Experiment attribution saved to cart.", {
        experiment: EXPERIMENT_KEY,
        variant: state.variant
      });

      return true;
    })
    .catch(function (error) {
      logError("Could not persist cart attribution.", error);
      return false;
    });
}

  /* =========================================================
     FETCH AND VALIDATE ASSIGNMENT
  ========================================================= */

  async function fetchExperimentAssignment() {
    var user = await waitForAmplitudeIdentity();

    log("Fetching assignment:", {
      experimentKey: EXPERIMENT_KEY,
      user: user
    });

    await state.experiment.fetch(user);

    state.allVariants = state.experiment.all();

    var variantObject = state.experiment.variant(EXPERIMENT_KEY);

    log("All variants returned:", state.allVariants);
    log("Assigned variant object:", variantObject);

    if (!variantObject || typeof variantObject.value !== "string") {
      throw new Error(
        "No string variant value returned for " + EXPERIMENT_KEY
      );
    }

    var assignedValue = variantObject.value;

    if (
      assignedValue !== CONTROL_VALUE &&
      assignedValue !== TREATMENT_VALUE
    ) {
      throw new Error(
        "Unexpected variant value '" + assignedValue +
        "'. Check the actual variant values in Amplitude."
      );
    }

    state.variantObject = variantObject;
    state.variant = assignedValue;
    state.assignmentValid = true;
    state.ready = true;
    persistExperimentAttributionToCart();

    showOnlyVariant(assignedValue);
    startVisibilityObserver();
    startExposureObserver();
    flushEventQueue();

    log("VALID ASSIGNMENT:", {
      experimentKey: EXPERIMENT_KEY,
      variantValue: assignedValue
    });

    return assignedValue;
  }

  /* =========================================================
     FALLBACK
  ========================================================= */

  function showFallbackControl(error) {
    state.variant = CONTROL_VALUE;
    state.variantObject = {
      value: CONTROL_VALUE,
      source: "fallback"
    };

    state.assignmentValid = false;
    state.ready = false;

    showOnlyVariant(CONTROL_VALUE);
    startVisibilityObserver();

    logError(
      "Assignment failed. Control is shown visually only; " +
      "this is not a valid experiment assignment.",
      error
    );
  }

  /* =========================================================
     INITIALIZATION
  ========================================================= */

  async function initialize() {
    if (state.initialized) return;
    state.initialized = true;

    installCompleteLookCartTracking();
    installVariantGuardStyles();

    document.documentElement.setAttribute(VARIANT_ATTRIBUTE, "pending");
    showOnlyVariant(null);

    log("Starting experiment.", {
      experimentKey: EXPERIMENT_KEY,
      controlValue: CONTROL_VALUE,
      treatmentValue: TREATMENT_VALUE,
      controlElements: getControlElements().length,
      treatmentElements: getTreatmentElements().length
    });

    try {
      await loadAmplitude();
      await loadExperiment();

      try {
        await fetchExperimentAssignment();
      } catch (firstError) {
        warn("Assignment failed once; retrying.", firstError);

        await new Promise(function (resolve) {
          window.setTimeout(resolve, ASSIGNMENT_RETRY_MS);
        });

        await fetchExperimentAssignment();
      }
    } catch (error) {
      showFallbackControl(error);
    }
  }

  /* =========================================================
     PUBLIC API — THEME INTEGRATION
  ========================================================= */

  window.HealixAmplitude = {
    ready: function () {
      return state.ready;
    },

    hasValidAssignment: function () {
      return state.assignmentValid;
    },

    getVariant: function () {
      return state.variant;
    },

    getVariantObject: function () {
      return state.variantObject;
    },

    getAllVariants: function () {
      return state.allVariants;
    },

    getExperimentKey: function () {
      return EXPERIMENT_KEY;
    },

    track: track,
    trackSectionViewed: trackSectionViewed,
    trackProductClick: trackProductClick,
    trackAddToCart: trackAddToCart,

    refreshVisibility: function () {
      if (state.assignmentValid && state.variant) {
        showOnlyVariant(state.variant);
      }
    }
  };

  installVariantGuardStyles();
  initialize();
})();
